import { Capacitor } from '@capacitor/core';
import {County} from "./enums";

export enum Role {
  ADMIN = 'Admin',
  CLIENT = 'Employee',
  HR = 'HR',
}

export const FIXED_BENEFIT_TYPE = 2;
export const SUBSCRIPTION_BENEFIT_TYPE = 1;
export const GIFT_TICKET_CATEGORY_ID = 6;
export const AUTH_HERO_IMAGES = {
  en: 'assets/images/login-hero-EN.jpg',
  ro: 'assets/images/login-hero-RO.jpg',
} as const;

export const getAuthHeroImage = (lang?: string | null): string =>
  lang === 'ro' ? AUTH_HERO_IMAGES.ro : AUTH_HERO_IMAGES.en;

export enum AddressesType {
  Shipping = 1,
  Billing = 2,
}

export enum CARD_STATUS {
  Blocked = 0,
  Expired = 1,
  Active = 2,
  Inactive = 3,
  Deleted = 4,
}

export enum AcquisitionType {
  OneTime = 1,
  Subscription = 2,
  AutoOrder = 3,
}

export enum BenefitType {
  General = 1,
  // Fixed = 1,
  Subscription = 2,
  Product = 3,
  MealTicket = 4,
  VacationTicket = 5,
  GiftTicket = 6,
  CultureTicket = 7,
  MedicalServicesOrInsurance = 8,
  PrivatePensionPillarIII = 9,
  Transport = 10,
  Fitness = 11,
  ProfessionalDevelopment = 12,
  Cashout = 13,
  GiftVoucher = 14,
  Insurance = 15
}

export enum FixedBenefitType {
  ReadOnly = 1,
  Reimbursement = 2
}

export enum ExpenseReportStatus {
  None = 0,
  Pending = 1,
  Approved = 2,
  Rejected = 3,
  SentToHr = 4
}

export const EXPENSE_REPORT_STATUS_LABEL = {
  [ExpenseReportStatus.Pending]: 'EXPENSE_REPORT.STATUS.PENDING',
  [ExpenseReportStatus.Approved]: 'EXPENSE_REPORT.STATUS.APPROVED',
  [ExpenseReportStatus.Rejected]: 'EXPENSE_REPORT.STATUS.REJECTED',
  [ExpenseReportStatus.SentToHr]: 'EXPENSE_REPORT.STATUS.SENT_TO_HR',
};

export enum BudgetType{
  None = 0,
  General = 1,
  Transport = 2,
  ProfessionalDevelopment = 3,
  Cashback = 4
}

export enum UnitType {
  None = 1,
  Units = 2,
  Months = 3,
}

export enum ShippingType {
  Voucher = 1,
  Email = 2,
  Courier = 3,
  HealthCard = 4,
  CardRecharge = 5
}

export const SHIPPING_TYPE_LABEL = {
  [ShippingType.Voucher]: 'SHIPPING_TYPE_LABEL.VOUCHER',
  [ShippingType.Email]: 'SHIPPING_TYPE_LABEL.EMAIL',
  [ShippingType.Courier]: 'SHIPPING_TYPE_LABEL.COURIER',
  [ShippingType.HealthCard]: 'SHIPPING_TYPE_LABEL.HEALTH_CARD',
  [ShippingType.CardRecharge]: 'SHIPPING_TYPE_LABEL.CARD_RECHARGE'
};

export const BENEFIT_TYPE_LABEL = {
  [BenefitType.General]: 'BENEFIT_TYPE_LABEL.GENERAL',
  // [BenefitType.Fixed]: 'BENEFIT_TYPE_LABEL.FIXED',
  [BenefitType.Subscription]: 'BENEFIT_TYPE_LABEL.SUBSCRIPTION',
  [BenefitType.Product]: 'BENEFIT_TYPE_LABEL.PRODUCT',
  [BenefitType.MealTicket]: 'BENEFIT_TYPE_LABEL.MEALTICKET',
  [BenefitType.VacationTicket]: 'BENEFIT_TYPE_LABEL.VACATIONTICKET',
  [BenefitType.CultureTicket]: 'BENEFIT_TYPE_LABEL.CULTURETICKET',
  [BenefitType.GiftTicket]: 'BENEFIT_TYPE_LABEL.GIFTTICKET',
  [BenefitType.MedicalServicesOrInsurance]: 'BENEFIT_TYPE_LABEL.MEDICAL',
  [BenefitType.PrivatePensionPillarIII]: 'BENEFIT_TYPE_LABEL.PENSION',
  [BenefitType.Transport]: 'BENEFIT_TYPE_LABEL.TRANSPORT',
  [BenefitType.Fitness]: 'BENEFIT_TYPE_LABEL.FITNESS',
  [BenefitType.ProfessionalDevelopment]: 'BENEFIT_TYPE_LABEL.PROFESSIONAL_DEVELOPMENT',
  [BenefitType.Cashout]: 'BENEFIT_TYPE_LABEL.CASHOUT',
  [BenefitType.GiftVoucher]: 'BENEFIT_TYPE_LABEL.GIFT_VOUCHER',
  [BenefitType.Insurance]: 'BENEFIT_TYPE_LABEL.INSURANCE',
};

export const UNIT_TYPE_LABEL = {
  [UnitType.None]: 'UNIT_TYPE_LABEL.NONE',
  [UnitType.Units]: 'UNIT_TYPE_LABEL.UNITS',
  [UnitType.Months]: 'UNIT_TYPE_LABEL.MONTHS',
};

export enum SubscriptionStatus {
  Created = 0,
  Valid = 1,
  Pending = 2,
  Cancelled = 3,
  Expired = 4
}

export enum OrderStatus {
  Created = 1,
  PaymentPending = 2,
  PaymentRefused = 3,
  PaymentAccepted = 4,
  Shipping = 6,
  Completed = 7,
  RequestToBeCancelled = 8,
  Cancelled = 9,
}

export const ORDER_STATUS_LABEL = {
  [OrderStatus.Created]: 'ORDER_STATUS_LABEL.CREATED',
  [OrderStatus.PaymentPending]: 'ORDER_STATUS_LABEL.PAYMENT_PENDING',
  [OrderStatus.PaymentRefused]: 'ORDER_STATUS_LABEL.PAYMENT_REFUSED',
  [OrderStatus.PaymentAccepted]: 'ORDER_STATUS_LABEL.PAYMENT_ACCEPTED',
  //legacy status
  [5]: 'ORDER_STATUS_LABEL.SHIPPING',
  [OrderStatus.Shipping]: 'ORDER_STATUS_LABEL.SHIPPING',
  [OrderStatus.Completed]: 'ORDER_STATUS_LABEL.COMPLETED',
  [OrderStatus.RequestToBeCancelled]:
    'ORDER_STATUS_LABEL.REQUEST_TO_BE_CANCELED',
  [OrderStatus.Cancelled]: 'ORDER_STATUS_LABEL.CANCELED',
};

export const SUBSCRIPTION_LABEL = {
  [SubscriptionStatus.Created]: 'SUBSCRIPTION_LABEL.CREATED',
  [SubscriptionStatus.Valid]: 'SUBSCRIPTION_LABEL.VALID',
  [SubscriptionStatus.Pending]: 'SUBSCRIPTION_LABEL.PENDING',
  [SubscriptionStatus.Cancelled]: 'SUBSCRIPTION_LABEL.CANCELLED',
  [SubscriptionStatus.Expired]: 'SUBSCRIPTION_LABEL.EXPIRED'
};

export enum PaymentStatus {
  PAYMENT_INITIATED = 0,
  PAYMENT_CONFIRMED = 1,
  PAYMENT_PAID = 2,
  PAYMENT_PAID_PENDING = 3,
  PAYMENT_CONFIRMED_PENDING = 4,
  PAYMENT_REJECTED = 5,
  PAYMENT_CREDIT = 6,
}

export enum IPNErrorCode{
  CARD_HAS_A_RISK = '16',
  CARD_NUMBER_IS_INCORRECT = '17',
  CLOSED_CARD = '18',
  CVV2_CODE_INCORRECT = '21',
  AMOUNT_IS_INCORRECT = '32',
  CURRENCY_IS_INCORRECT = '33',
  TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER = '34',
  TRANSACTION_DECLINED = '35',
  TRANSACTION_REJECTED_BY_ANTIFRAUD_FILTERS = '36',
  TRANSACTION_DECLINED_BREAKING_THE_LAW = '37',
  INVALID_REQUEST = '48',
  DUPLICATE_PREAUTH = '49',
  DUPLICATE_AUTH = '50',
  YOU_CAN_ONLY_CANCEL_A_PREAUTH_ORDER = '51',
  YOU_CAN_ONLY_CONFIRM_A_PREAUTH_ORDER = '52',
  YOU_CAN_ONLY_CREDIT_A_CONFIRMED_ORDER = '53',
  CREDIT_AMOUNT_IS_HIGHER_THAN_AUTH_AMOUNT = '54',
  CAPTURE_AMOUNT_IS_HIGHER_THAN_PREAUTH_AMOUNT = '55',
  DUPLICATE_REQUEST = '56',
  GENERIC_ERROR = '99',
  CARD_IS_EXPIRED = '19',
  INSUFFICIENT_FUNDS = '20',
  ISSUER_IS_UNAVAILABLE = '22',
}

export const PAYMENT_STATUS_LABEL = {
  [PaymentStatus.PAYMENT_INITIATED]: 'PAYMENT_STATUS_LABEL.PAYMENT_INITIATED',
  [PaymentStatus.PAYMENT_CONFIRMED]: 'PAYMENT_STATUS_LABEL.PAYMENT_CONFIRMED',
  [PaymentStatus.PAYMENT_PAID]: 'PAYMENT_STATUS_LABEL.PAYMENT_PAID',
  [PaymentStatus.PAYMENT_PAID_PENDING]:
    'PAYMENT_STATUS_LABEL.PAYMENT_PAID_PENDING',
  [PaymentStatus.PAYMENT_CONFIRMED_PENDING]:
    'PAYMENT_STATUS_LABEL.PAYMENT_CONFIRMED_PENDING',
  [PaymentStatus.PAYMENT_REJECTED]: 'PAYMENT_STATUS_LABEL.PAYMENT_REJECTED',
  [PaymentStatus.PAYMENT_CREDIT]: 'PAYMENT_STATUS_LABEL.PAYMENT_CREDIT',
};

export const IPN_ERROR_CODE_STATUS_LABEL = {
  [IPNErrorCode.CARD_IS_EXPIRED]: 'IPN_ERROR_CODE_STATUS_LABEL.CARD_IS_EXPIRED',
  [IPNErrorCode.INSUFFICIENT_FUNDS]: 'IPN_ERROR_CODE_STATUS_LABEL.INSUFFICIENT_FUNDS',
  [IPNErrorCode.TRANSACTION_DECLINED]: 'IPN_ERROR_CODE_STATUS_LABEL.TRANSACTION_DECLINED',
  [IPNErrorCode.CARD_HAS_A_RISK]: 'IPN_ERROR_CODE_STATUS_LABEL.CARD_HAS_A_RISK',
  [IPNErrorCode.CARD_NUMBER_IS_INCORRECT]: 'IPN_ERROR_CODE_STATUS_LABEL.CARD_NUMBER_IS_INCORRECT',
  [IPNErrorCode.CLOSED_CARD]: 'IPN_ERROR_CODE_STATUS_LABEL.CLOSED_CARD',
  [IPNErrorCode.AMOUNT_IS_INCORRECT]: 'IPN_ERROR_CODE_STATUS_LABEL.AMOUNT_IS_INCORRECT',
  [IPNErrorCode.CURRENCY_IS_INCORRECT]: 'IPN_ERROR_CODE_STATUS_LABEL.CURRENCY_IS_INCORRECT',
  [IPNErrorCode.TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER]: 'IPN_ERROR_CODE_STATUS_LABEL.TRANSACTION_NOT_PERMITTED_TO_CARDHOLDER',
  [IPNErrorCode.TRANSACTION_REJECTED_BY_ANTIFRAUD_FILTERS]: 'IPN_ERROR_CODE_STATUS_LABEL.TRANSACTION_REJECTED_BY_ANTIFRAUD_FILTERS',
  [IPNErrorCode.TRANSACTION_DECLINED_BREAKING_THE_LAW]: 'IPN_ERROR_CODE_STATUS_LABEL.TRANSACTION_DECLINED_BREAKING_THE_LAW',
  [IPNErrorCode.INVALID_REQUEST]: 'IPN_ERROR_CODE_STATUS_LABEL.INVALID_REQUEST',
  [IPNErrorCode.DUPLICATE_PREAUTH]: 'IPN_ERROR_CODE_STATUS_LABEL.DUPLICATE_PREAUTH',
  [IPNErrorCode.DUPLICATE_AUTH]: 'IPN_ERROR_CODE_STATUS_LABEL.DUPLICATE_AUTH',
  [IPNErrorCode.YOU_CAN_ONLY_CANCEL_A_PREAUTH_ORDER]: 'IPN_ERROR_CODE_STATUS_LABEL.YOU_CAN_ONLY_CANCEL_A_PREAUTH_ORDER',
  [IPNErrorCode.YOU_CAN_ONLY_CONFIRM_A_PREAUTH_ORDER]: 'IPN_ERROR_CODE_STATUS_LABEL.YOU_CAN_ONLY_CONFIRM_A_PREAUTH_ORDER',
  [IPNErrorCode.YOU_CAN_ONLY_CREDIT_A_CONFIRMED_ORDER]: 'IPN_ERROR_CODE_STATUS_LABEL.YOU_CAN_ONLY_CREDIT_A_CONFIRMED_ORDER',
  [IPNErrorCode.CREDIT_AMOUNT_IS_HIGHER_THAN_AUTH_AMOUNT]: 'IPN_ERROR_CODE_STATUS_LABEL.CREDIT_AMOUNT_IS_HIGHER_THAN_AUTH_AMOUNT',
  [IPNErrorCode.CAPTURE_AMOUNT_IS_HIGHER_THAN_PREAUTH_AMOUNT]: 'IPN_ERROR_CODE_STATUS_LABEL.CAPTURE_AMOUNT_IS_HIGHER_THAN_PREAUTH_AMOUNT',
  [IPNErrorCode.GENERIC_ERROR]: 'IPN_ERROR_CODE_STATUS_LABEL.GENERIC_ERROR',
  [IPNErrorCode.CVV2_CODE_INCORRECT]: 'IPN_ERROR_CODE_STATUS_LABEL.CVV2_CODE_INCORRECT',
  [IPNErrorCode.ISSUER_IS_UNAVAILABLE]: 'IPN_ERROR_CODE_STATUS_LABEL.ISSUER_IS_UNAVAILABLE',
};

export enum Period {
  One = 1,
  Tree = 2,
  Six = 3,
  Twelve = 4,
}

export const PERIOD_LABEL = {
  [Period.One]: '1',
  [Period.Tree]: '3',
  [Period.Six]: '6',
  [Period.Twelve]: '12',
};

export enum SupportStatusType {
  New = 1,
  InProgress = 2,
  Done = 3,
}

export enum Issue {
  LoginPassword = 'Login and password problem',
  FlexibleBenefits='Flexible benefits problem',
  Taxes = 'Taxes and fees problem',
  PlacedOrders = 'Placed orders problem',
  Others = 'Other problems'
}

export const ISSUE_LABEL = {
  [Issue.LoginPassword]: 'ISSUE_LABEL.LOGIN_PASSWORD',
  [Issue.FlexibleBenefits]: 'ISSUE_LABEL.FLEXIBLE_BENEFITS',
  [Issue.Taxes]: 'ISSUE_LABEL.TAXES',
  [Issue.PlacedOrders]: 'ISSUE_LABEL.PLACED_ORDERS',
  [Issue.Others]: 'ISSUE_LABEL.OTHERS',
};

export enum CompanyTaxDistribution {
  EMPLOYEE = 1,
  EMPLOYEE_SALARY = 2,
  COMPANY = 3,
}

export const COMPANY_TAX_DISTRIBUTION_LABEL = {
  [CompanyTaxDistribution.EMPLOYEE]: 'COMPANY_TAX_DISTRIBUTION_LABEL.EMPLOYEE',
  [CompanyTaxDistribution.EMPLOYEE_SALARY]:
    'COMPANY_TAX_DISTRIBUTION_LABEL.EMPLOYEE_SALARY',
  [CompanyTaxDistribution.COMPANY]: 'COMPANY_TAX_DISTRIBUTION_LABEL.COMPANY',
};

export const selectValuesSeparator = 'c8c55a16-4de3-11ec-81d3-0242ac130003';

export enum Kinship {
  FATHER = 1,
  MOTHER = 2,
  BROTHER = 3,
  SISTER = 4,
  HUSBAND = 5,
  WIFE = 6,
  CHILD = 7
}

export enum ENV {
  LOCAL = 1,
  DEMO = 2,
  DEV = 3,
  TEST = 4,
  PROD = 5
}

export const KINSHIP_LABEL = {
  [Kinship.FATHER]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_FATHER',
  [Kinship.MOTHER]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_MOTHER',
  [Kinship.BROTHER]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_BROTHER',
  [Kinship.SISTER]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_SISTER',
  [Kinship.HUSBAND]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_HUSBAND',
  [Kinship.WIFE]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_WIFE',
  [Kinship.CHILD]: 'BENEFIT_SUMMARY.ADD_EDIT_FORM.KINSHIP_CHILD'
};

export enum PricingPlan {
  FLEX = 0,
  LITE = 1
}

export const PRICING_PLAN_LABEL = {
  [PricingPlan.FLEX]: 'FLEX',
  [PricingPlan.LITE]: 'LITE'
};

export const CountyLabel = {
  [County.WholeCountry]: 'COUNTY.WHOLE_COUNTRY',
  [County.AB]: "COUNTY.AB",
  [County.AR]: "COUNTY.AR",
  [County.AG]: "COUNTY.AG",
  [County.BC]: "COUNTY.BC",
  [County.BH]: "COUNTY.BH",
  [County.BN]: "COUNTY.BN",
  [County.BR]: "COUNTY.BR",
  [County.BT]: "COUNTY.BT",
  [County.BV]: "COUNTY.BV",
  [County.B]: "COUNTY.B",
  [County.BZ]: "COUNTY.BZ",
  [County.CS]: "COUNTY.CS",
  [County.CL]: "COUNTY.CL",
  [County.CJ]: "COUNTY.CJ",
  [County.CT]: "COUNTY.CT",
  [County.CV]: "COUNTY.CV",
  [County.DB]: "COUNTY.DB",
  [County.DJ]: "COUNTY.DJ",
  [County.GL]: "COUNTY.GL",
  [County.GR]: "COUNTY.GR",
  [County.GJ]: "COUNTY.GJ",
  [County.HR]: "COUNTY.HR",
  [County.HD]: "COUNTY.HD",
  [County.IL]: "COUNTY.IL",
  [County.IS]: "COUNTY.IS",
  [County.IF]: "COUNTY.IF",
  [County.MM]: "COUNTY.MM",
  [County.MH]: "COUNTY.MH",
  [County.MS]: "COUNTY.MS",
  [County.NT]: "COUNTY.NT",
  [County.OT]: "COUNTY.OT",
  [County.PH]: "COUNTY.PH",
  [County.SM]: "COUNTY.SM",
  [County.SJ]: "COUNTY.SJ",
  [County.SB]: "COUNTY.SB",
  [County.SV]: "COUNTY.SV",
  [County.TR]: "COUNTY.TR",
  [County.TM]: "COUNTY.TM",
  [County.TL]: "COUNTY.TL",
  [County.VS]: "COUNTY.VS",
  [County.VL]: "COUNTY.VL",
  [County.VN]: "COUNTY.VN"
}

export const CountyMap: Record<string, County> = {
  // București
  "bucuresti": County.B,
  "bucurești": County.B,
  "bucharest": County.B,

  // Alba
  "alba": County.AB,

  // Arad
  "arad": County.AR,

  // Argeș
  "arges": County.AG,
  "argeș": County.AG,

  // Bacău
  "bacau": County.BC,
  "bacău": County.BC,

  // Bihor
  "bihor": County.BH,

  // Bistrița-Năsăud
  "bistrita": County.BN,
  "bistrița": County.BN,
  "bistrita-nasaud": County.BN,
  "bistrița-năsăud": County.BN,
  "bistrita nasaud": County.BN,

  // Brăila
  "braila": County.BR,
  "brăila": County.BR,

  // Botoșani
  "botosani": County.BT,
  "botoșani": County.BT,

  // Brașov
  "brasov": County.BV,
  "brașov": County.BV,

  // Buzău
  "buzau": County.BZ,
  "buzău": County.BZ,

  // Caraș-Severin
  "caras-severin": County.CS,
  "caraș-severin": County.CS,
  "caras severin": County.CS,

  // Călărași
  "calarasi": County.CL,
  "călărași": County.CL,

  // Cluj
  "cluj": County.CJ,

  // Constanța
  "constanta": County.CT,
  "constanța": County.CT,

  // Covasna
  "covasna": County.CV,

  // Dâmbovița
  "dambovita": County.DB,
  "dâmbovița": County.DB,

  // Dolj
  "dolj": County.DJ,

  // Galați
  "galati": County.GL,
  "galați": County.GL,

  // Giurgiu
  "giurgiu": County.GR,

  // Gorj
  "gorj": County.GJ,

  // Harghita
  "harghita": County.HR,

  // Hunedoara
  "hunedoara": County.HD,

  // Ialomița
  "ialomita": County.IL,
  "ialomița": County.IL,

  // Iași
  "iasi": County.IS,
  "iași": County.IS,

  // Ilfov
  "ilfov": County.IF,

  // Maramureș
  "maramures": County.MM,
  "maramureș": County.MM,

  // Mehedinți
  "mehedinti": County.MH,
  "mehedinți": County.MH,

  // Mureș
  "mures": County.MS,
  "mureș": County.MS,

  // Neamț
  "neamt": County.NT,
  "neamț": County.NT,

  // Olt
  "olt": County.OT,

  // Prahova
  "prahova": County.PH,

  // Satu Mare
  "satu mare": County.SM,

  // Sălaj
  "salaj": County.SJ,
  "sălaj": County.SJ,

  // Sibiu
  "sibiu": County.SB,

  // Suceava
  "suceava": County.SV,

  // Teleorman
  "teleorman": County.TR,

  // Timiș
  "timis": County.TM,
  "timiș": County.TM,

  // Tulcea
  "tulcea": County.TL,

  // Vaslui
  "vaslui": County.VS,

  // Vâlcea
  "valcea": County.VL,
  "vâlcea": County.VL,

  // Vrancea
  "vrancea": County.VN
};


export const NotificationAlertType = ['danger', 'warning', 'success', 'info', 'primary', 'secondary', 'dark'];

export const RO_MONTH_LABELS = ['Ianuarie', 'Februarie', 'Martie', 'Aprilie', 'Mai', 'Iunie', 'Iulie', 'August', 'Septembrie', 'Octombrie', 'Noiembrie', 'Decembrie'];
export const EN_MONTH_LABELS = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];

export const quillEditorSettings = {
  toolbar: [
    ['bold', 'italic', 'underline', 'strike','blockquote'],
    [{ list: 'ordered' }, { list: 'bullet' }],
    [{ 'indent': '-1'}, { 'indent': '+1' }]
  ],
};

export function isMobile(): boolean {
  return Capacitor.getPlatform() === 'android' || Capacitor.getPlatform() === 'ios';
}

/**
 * Extracts the insurance category from a benefit name matching:
 * ^Asigur[aă]ri[ -](Auto|Locuin[tț]e|Turism|S[aă]n[aă]tate & Via[tț][aă]|R[aă]spunderi)$
 * Returns the returnUrl fragment like /home/asigurari#auto, or null if no match.
 */
export function getInsuranceReturnUrl(benefitName: string): string | null {
  const match = benefitName?.match(/^Asigur[aă]ri[ -](Auto|Locuin[tț]e|Turism|S[aă]n[aă]tate & Via[tț][aă]|R[aă]spunderi)$/);
  if (!match) { return null; }
  const category = match[1].split(/[ &]/)[0].toLowerCase();
  return `/home/asigurari#${category}`;
}

export function GetProviderName(currentProviderName: string, subdomain: string) {
  if (currentProviderName?.includes('NN Pensii')) {
    if (subdomain === 'pepsico') {
      return 'NN Asigurari de Viata - pensii facultative - contribuție personală';
    } else {
      return 'NN Asigurari de Viata - pensii facultative';
    }
  }
  return currentProviderName;
}

// eslint-disable-next-line max-len
export const emailRegex = /^(?=.{1,254}$)(?=.{1,64}@)[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-zA-Z0-9!#$%&'*+/=?^_`{|}~-]+)*@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$/;
export const cnpRegex = /^[1-9]\d{2}(0[1-9]|1[0-2])(0[1-9]|[12]\d|3[01])(0[1-9]|[1-4]\d|5[0-2]|7[0-9]|8[0-2]|9[0-9])(00[1-9]|0[1-9]\d|[1-9]\d\d)\d$/;
export const phonePattern = /^[0-9]{10}$/;

// Masks a phone number for display, keeping only the last 4 digits visible
// (e.g. "0712345678" -> "******5678"). Used in read-only display contexts
// (profile addresses, beneficiaries) where sensitive data shouldn't be shown
// in full, unlike editable form fields which use an eye-toggle instead.
export function maskPhoneNumber(phone: string | null | undefined): string {
  if (!phone) {
    return '';
  }
  const visibleDigits = 4;
  if (phone.length <= visibleDigits) {
    return phone;
  }
  return '*'.repeat(phone.length - visibleDigits) + phone.slice(-visibleDigits);
}

// Masks a CNP for display, keeping only the last 6 digits visible
// (e.g. "1960101221144" -> "*******221144").
export function maskCnp(cnp: string | null | undefined): string {
  if (!cnp) {
    return '';
  }
  const visibleDigits = 6;
  if (cnp.length <= visibleDigits) {
    return cnp;
  }
  return '*'.repeat(cnp.length - visibleDigits) + cnp.slice(-visibleDigits);
}

// Masks an email for display (e.g. "abcdefgh@gmail.com" -> "abc***@*il.com"):
// the local part shows its first 3 characters followed by "***", and the
// domain name shows only its last 2 characters before the TLD, prefixed
// with "*" (the TLD itself stays fully visible).
export function maskEmail(email: string | null | undefined): string {
  if (!email) {
    return '';
  }
  const atIndex = email.indexOf('@');
  if (atIndex === -1) {
    return email;
  }
  const localPart = email.slice(0, atIndex);
  const domainPart = email.slice(atIndex + 1);
  const maskedLocal = localPart.slice(0, 3) + '***';

  const lastDotIndex = domainPart.lastIndexOf('.');
  if (lastDotIndex === -1) {
    return `${maskedLocal}@${domainPart}`;
  }
  const domainName = domainPart.slice(0, lastDotIndex);
  const tld = domainPart.slice(lastDotIndex);
  const maskedDomain = '*' + domainName.slice(-2) + tld;
  return `${maskedLocal}@${maskedDomain}`;
}
export const numericIdRegex = /^\d+$/;
export const INITIAL_LOAD_CNT: number = 9;
export const LOAD_MORE_CNT: number = 6;
